<template>
<div class="ActivityOrderList">
    <orderList></orderList>
</div>
</template>

<script>
import OrderList from 'views/brandBusiness/activityMgt/order/OrderList.vue'
export default {
    name: 'BBActivityOrderList',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {
        OrderList
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ActivityOrderList {
}
</style>
